import api from '../../api/leadRealAPI'
import router from '../../router'

export default {
  namespaced: true,

  state: {
    memberData: null,
    invalidEmail: null,
    deleteMsg: null,
    progress: false
  },

  getters: {
    memberData: state => state.memberData,
    invalidEmail: state => state.invalidEmail,
    deleteMsg: state => state.deleteMsg
  },

  mutations: {
    setMemberData (state, memberData) {
      state.memberData = memberData
    },
    setProgress (state, progress) {
      state.progress = progress
    },
    setDeleteMsg (state, deleteMsg) {
      state.deleteMsg = deleteMsg
    },
    setInvalidEmail (state, invalidEmail) {
      state.invalidEmail = invalidEmail
    }
  },

  actions: {
    getMember ({ commit }, data) {
      commit('setMemberData', null)
      api
        .get('/admin/memberSpecific/' + data)
        .then(response => {
          if (response.data.status === 'メンバーが見つかりません。') {
            router.push({ name: 'Admin Member List' })
          } else if (response.data.data[0].memberinfo === null) {
            router.push({ name: 'Admin Member List' })
          }
          commit('setApiStatus', null, { root: true })
          commit('setMemberData', response.data.data[0])
        }).catch((error) => {
          if (error) {
            // router.push({ name: 'Admin Member List' })
            // commit('setApiStatus', 'メンバーが見つかりません。', { root: true })
            // setTimeout(() => commit('setApiStatus', null, { root: true }), 3000)
          }
        })
    },
    updateMember ({ commit, state }, data) {
      api
        .post('/admin/updateMember/' + state.memberData.id, data)
        .then(response => {
          commit('setApiStatus', response.data.status, { root: true })
          setTimeout(() => commit('setApiStatus', null, { root: true }), 3000)
        })
        .catch(() => {
          commit('setInvalidEmail', 'このメールアドレスは使用できません。')
        })
    },
    deleteMember ({ commit, state }, data) {
      api
        .post('/admin/deleteMember/' + state.memberData.id, data)
        .then(response => {
          commit('setDeleteMsg', response.data.status)
          setTimeout(() => commit('setDeleteMsg', null), 3000)
          router.push({ name: 'Admin Member List' })
        })
        .catch(() => {})
    }
  }
}
